module.exports = __webpack_public_path__ + "img/bg00.c377f98b.png";